export default __webpack_public_path__ + "static/media/silver.522c1934.webp";